import { z } from 'zod';

/////////////////////////////////////////
// ACTION TYPE SCHEMA
/////////////////////////////////////////

export const ActionTypeSchema = z.object({
  actiontypeId: z.number().int(),
  cityId: z.number().int(),
  actionName: z.string(),
  displayOrder: z.number().int(),
  isInspection: z.number().int(),
  popupTemplate: z.string(),
})

export type ActionType = z.infer<typeof ActionTypeSchema>

export default ActionTypeSchema;
